import {BillingOptionView} from "@/lib/types";

export const OptionKeys = {
  badgeAvailableNow: "badge_available_now",
  headOfList: "head_list",
  monthExtension: "month_extension",
  badgeLastDatesAvailable: "badge_last_dates_available",
  photosPack: "photos_pack",
  contextualList: "contextual_list",
}

export function OptionToBadge(o: BillingOptionView): { name: string, className: string } | undefined {
  if (!o) {
    return undefined
  }

  switch (o.option_key) {
    case OptionKeys.badgeAvailableNow:
      return {name: 'Disponible maintenant', className: 'bg-cyan-50 border-cyan-500 text-cyan-500 text-center'}
    case OptionKeys.badgeLastDatesAvailable:
      return {
        name: 'Dernières dates disponibles',
        className: 'bg-orange-50 border-orange-500 text-orange-500 text-center'
      }
    case OptionKeys.headOfList:
      return {name: 'A la Une', className: 'bg-yellow-50 border-yellow-500 text-yellow-500 text-center'}
    case OptionKeys.photosPack:
      return {name: '+ de photos', className: 'bg-yellow-50 border-yellow-700 text-yellow-700 text-center'}
    case OptionKeys.contextualList:
      return {name: 'A voir aussi', className: 'bg-yellow-50 border-yellow-700 text-yellow-700 text-center'}
  }
  console.warn('no badge for options: ', o.option_key)
  return undefined
}

export function OptionsToBadges(opts: BillingOptionView[]): { name: string, className: string }[] {
  //@ts-ignore
  return opts.map(OptionToBadge).filter(o => o) ?? []
}